  import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/index.vue'
import Product_list from '@/components/Product_list'
import Product_detail from '@/components/Product_detail'

import Cart from '@/components/Cart'
import Checkout from '@/components/Checkout'
import Thankyou from '@/components/Thankyou'
import Profile from '@/components/Profile'
import Return from '@/components/Return'
import Landing from '@/components/Home/Landing'
import Store from '@/components/Store'
import Wishlist from '@/components/Wishlist'
import StoreProduct from '@/components/StoreProduct'
import StoreE from '@/components/StoreE'
import Grocery from '@/components/Grocery'
import StoreCredit from '@/components/StoreCredit'
import underDevelop from '@/components/underDevelop'


//import Login from '@/components/Login'
import Static_page from '@/components/Static_page'
import Dashboard from '@/components/Dashboard'
import Order from '@/components/Order'
import Address_book from '@/components/Address_book'
import Order_detail from '@/components/Order_detail'
import Payment_error from '@/components/Payment_error'
import Support from '@/components/Support'
import Company from '@/components/Company'
import Privacy_policy from '@/components/Privacy_policy'
import Contact_us from '@/components/Contact_us'
import Sitemap from '@/components/Sitemap'
import Store_locator from '@/components/Store_locator'
import Fashion_awards from '@/components/Fashion_awards'
import St_search from '@/components/St_search.vue';
import NotFound from '@/components/404.vue';
import cancel_policy from '@/components/Cancel_and_Return_Policy'
import ship_delivery from '@/components/Ship_and_Delivery_Policy';
import refund_policy from '@/components/Refund_Policy';
import personality from '@/components/Personality';
import everyday from '@/components/Everyday_icon';
import trendsetter from '@/components/Trendsetter';
import minimalist from '@/components/Minimalist';
import nuvo_tradionalist from '@/components/Nuvo_tradionalist';
import mobileBrand from '@/components/mobleBrand';
import Categories from  '@/components/Categories';
Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) { 
   return savedPosition
  } else {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
     
 if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position
      }
      return false
    }
    return new Promise(resolve => {
      if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
      }
        this.app.$root.$once('triggerScroll', () => {
          // setTimeout(() => {
        resolve(position)
      // }, 500)
      })
    })
  }
}
export default new Router({
   mode: 'history',
   routes: [
    
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true ,
      meta:{scrollToTop:true}
     },
     {
      path: '/categories.html',
      name: 'Categories',
      component: Categories,
      props: true ,
      meta:{scrollToTop:true}
    },
     {
      path: '/mobile-brand.html',
      name: 'mobileBrand',
      component: mobileBrand,
      props: true ,
      
      meta:{scrollToTop:true}
    },
     {
      path: '/underDevelop.html',
      name: 'underDevelop',
      component: underDevelop,
      props: true ,
      meta:{scrollToTop:true}
    },
    
    {
      path: '/store.html',
      name: 'Store',
      component: Store,
      props: true ,
      meta:{scrollToTop:true}
     },
    {
      path: '/store-credit.html',
      name: 'StoreCredit',
      component: StoreCredit,
      props: true ,
      meta:{scrollToTop:true}
    },


    {
      path: '/wishlist.html',
      name: 'Wishlist',
      component: Wishlist,
      props: true ,
      meta:{scrollToTop:true}
    },
    {
      path: '/store-product.html',
      name: 'StoreProduct',
      component: StoreProduct,
      props: true ,
      meta:{scrollToTop:true}
    },
    {
      path: '/Landing.html',
      name: 'Landing',
      component: Landing,
      props: true ,
      meta:{scrollToTop:true}
    },
    {
      path: '/grocery.html',
      name: 'Grocery',
      component: Grocery,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
    {
      path: '/storee.html',
      name: 'StoreE',
      component: StoreE,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
    {
      path: '/return.html',
      name: 'return',
      component: Return,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
   

    {
      path: '/personality.html', 
      name:'personality',
      component: personality,
      props: true,
      meta: { bodyClass: 'personality_questions static-pages' ,scrollToTop:true }
    },
    
    {
      path: '/trendsetter.html', 
      name:'trendsetter',
      component: trendsetter,
      props: true,
      meta: { bodyClass: 'personality_questions static-pages' , scrollToTop:true }
    },
    {
      path: '/minimalist.html', 
      name:'minimalist',
      component: minimalist,
      props: true,
      meta: { bodyClass: 'personality_questions static-pages' ,scrollToTop:true }
    },
    {
      path: '/nuvo-traditional.html', 
      name:'neo_traditional',
      component: nuvo_tradionalist,
      props: true,
      meta: { bodyClass: 'personality_questions static-pages' ,scrollToTop:true }
    },
    {
      path: '/everyday.html', 
      name:'everyday',
      component: everyday,
      props: true,
      meta: { bodyClass: 'personality_questions static-pages' ,scrollToTop:true}
    },
    {
      path: '/page/:id.html',
      name: 'Static',
      component: Static_page,
      props: true ,
      meta: { bodyClass: 'static-pages' }
    },
    {
      path: '/store-locator.html', 
      name:'store_locator',
      component: Store_locator,
      props: true,
      meta: { bodyClass: 'store-locator static-pages' ,scrollToTop:true }
    },
    {
      path: '/st-search', 
      name:'st_search',
      component: St_search,
      props: true,
      meta: { bodyClass: 'St_search' ,scrollToTop:true}
    },
    {
      path: '/category/:menu_url_key.html',
      name: 'list',
      component: Product_list,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
    {
      path: '/fashion-awards.html', 
      name:'fashion_awards',
      component: Fashion_awards,
      props: true,
      meta: { bodyClass: 'static-pages' ,scrollToTop:true}
    },
    {
      path: '*', 
      name:'NotFound',
      component: NotFound,
      props: true,
      meta: { bodyClass: 'static-pages',scrollToTop:true }
    },
    {
      path: '/faqs.html',
      name: 'support',
      component: Support,
      props: true,
      meta: { bodyClass: 'static-pages' ,scrollToTop:true }
    },
    {
      path: '/about.html',
      name: 'company',
      component: Company,
      props: true,
      meta: { bodyClass: 'static-pages' ,scrollToTop:true }
    },
    {
      path: '/privacy-policy.html',
      name: 'privacy_policy',
      component: Privacy_policy,
      props: true,
      meta: { bodyClass: 'static-pages' ,scrollToTop:true }
    },
    {
      path: '/contact.html',
      name: 'contact_us',
      component: Contact_us,
      props: true,
      meta: { bodyClass: 'static-pages' ,scrollToTop:true }
    },
    {
      path: '/sitemap.html',
      name: 'sitemap',
      component: Sitemap,
      props: true,
      meta: { bodyClass: 'static-pages' , scrollToTop:true}
    },
    {
      path: '/gift-card.html',
      name: 'gift-card',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bags.html',
      name: 'bags',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/disha-patani-s-must-haves.html',
      name: 'disha-patani-s-must-haves',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/work-wear.html',
      name: 'work-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/occasion-ready.html',
      name: 'occasion-ready',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/everyday-dress.html',
      name: 'everyday-dress',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/casual-wear.html',
      name: 'casual-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/footwear-wedges.html',
      name: 'footwear-wedges',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/better-together.html',
      name: 'better-together',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/footwear.html',
      name: 'footwear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/mask.html',
      name: 'mask',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/footwear-flats.html',
      name: 'footwear-flats',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/footwear-heels.html',
      name: 'footwear-heels',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/flat-40-off.html',
      name: 'flat-40-off',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/flat-50-off.html',
      name: 'flat-50-off',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-kurta-set.html',
      name: 'top-wear-kurta-set',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-kurtis.html',
      name: 'top-wear-kurtis',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bottom-wear-trousers.html',
      name: 'bottom-wear-trousers',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/new-arrivals.html',
      name: 'new-arrivals',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/w-new-arrivals.html',
      name: 'new-arrivals',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/aurelia-new-arrivals.html',
      name: 'new-arrivals',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear.html',
      name: 'top-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-gilet.html',
      name: 'top-wear-gilet',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-kurtas.html',
      name: 'top-wear-kurtas',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-sets-dresses.html',
      name: 'top-wear-sets-dresses',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bottom-wear.html',
      name: 'bottom-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bottom-wear-skirts.html',
      name: 'bottom-wear-skirts',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bottom-wear-palazzo-pants.html',
      name: 'bottom-wear-palazzo-pants',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/bottom-wear-churidars-salwar.html',
      name: 'bottom-wear-churidars-salwar',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/winter-wear.html',
      name: 'winter-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/winter-wear-outerwear.html',
      name: 'winter-wear-outerwear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/winter-wear-winter-kurta.html',
      name: 'winter-wear-winter-kurta',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/winter-wear-winter-bottomwear.html',
      name: 'winter-wear-winter-bottomwear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/winter-wear-shawl.html',
      name: 'winter-wear-shawl',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/drapes-wear.html',
      name: 'drapes-wear',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/drapes-wear-dupatta.html',
      name: 'drapes-wear-dupatta',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/drapes-wear-scarf.html',
      name: 'drapes-wear-scarf',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/drapes-wear-shawl.html',
      name: 'drapes-wear-shawl',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    }, 
    {
      path: '/wishful.html',
      name: 'wishful',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-palazzos-and-pants.html',
      name: 'wishful-palazzos-and-pants',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-churidars-and-salwars.html',
      name: 'wishful-churidars-and-salwars',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-kurtas.html',
      name: 'wishful-kurtas',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-skirts.html',
      name: 'wishful-skirts',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-dupattas.html',
      name: 'wishful-dupattas',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/wishful-sets-dresses.html',
      name: 'wishful-sets-dresses',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/collections/:url_key.html',
      name: 'collections',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/sale.html',
      name: 'sale',
      component: Product_list,
      props: true ,
      meta:{ scrollToTop:true }
    },
    {
      path: '/top-wear-tops.html',
      name: 'top-wear-tops',
      component: Product_list,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
    {
      path: '/cart.html',
      name: 'cart',
      component: Cart,
      props: true ,
      meta:{
        scrollToTop:true
      }
    },
    {
      path: '/checkout.html',
      name: 'Checkout',
      component: Checkout,
      props: true,
      meta: { bodyClass: 'checkout' ,scrollToTop:true }
    },
    {
      path: '/thankyou.html',
      name: 'Thankyou',
      component: Thankyou,
      props: true,
      meta: { bodyClass: 'thankyou' ,scrollToTop:true}
    },
    // {
    //   path: '/login.html',
    //   name: 'login',
    //   component: Login,
    //   props: true,
    //   meta: { bodyClass: 'account-login' }
    // },
    {
      path: '/account-dashboard.html',
      name: 'dashboard',
      component: Dashboard,
      props: true,
      meta: { bodyClass: 'address-book',scrollToTop:true }
    },
    {
      path: '/profile.html',
      name: 'profile',
      component: Profile,
      props: true,
      meta: { bodyClass: 'address-book',scrollToTop:true }
    },
    {
      path: '/my-order.html',
      name: 'order',
      component: Order,
      props: true,
      meta:{scrollToTop:true}
    },
    {
      path: '/order-detail.html',
      name: 'order-detail',
      component: Order_detail,
      props: true,
      meta:{scrollToTop:true}
    },
    {
      path: '/address-book.html',
      name: 'address_book',
      component: Address_book,
      props: true,
      meta: { bodyClass: 'address-book' , scrollToTop:true }
    },
    {
      path: '/payment-error.html',
      name: 'payment_error',
      component: Payment_error,
      props: true,
      meta: { bodyClass: 'payment-error' , scrollToTop:true }
    },
    {
      path: '/delivery-policy.html',
      name: 'ship_delivery',
      component: ship_delivery,
      props: true,
      meta: { bodyClass: 'static-pages' , scrollToTop:true}
    },
    {
      path: '/refund-policy.html',
      name: 'refund_policy',
      component: refund_policy,
      props: true,
      meta: { bodyClass: 'static-pages', scrollToTop:true }
    },
    {
      path: '/return-policy.html',
      name: 'cancel_policy',
      component: cancel_policy,
      props: true,
      meta: { bodyClass: 'static-pages' , scrollToTop:true }
    },
    {
      path: '/:pro_url_key.html',
      name: 'detail',
      component: Product_detail,
      props: true ,
      meta: { scrollToTop: true }
    },
    
  ],
  scrollBehavior,
})